/* eslint-disable eqeqeq */
/* eslint-disable no-lone-blocks */
import React, { useEffect } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as AppConstants from '../AppConstants';
import noImage from '../images/noimage.png';
import { handleSmallImages } from '../Utils';

const mapStyles = {
  width: '100vw',
  height: '100vh',
};

export function SingleMap (props)
{
  const [selectedPlace, setSelectedPlace] = React.useState(null);
  const [showingInfoWindow, setShowingInfoWindow] =
    React.useState(false);
  const [color, setColor] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { propertyCord } = useSelector((state) => state);

  useEffect(() =>
  {
    document.title = 'Map';
    window.scrollTo(0, 0);
  }, []);

  const onMarkerClick = (store, color) =>
  {
    setSelectedPlace(store);
    setShowingInfoWindow(true);
    setColor(color);
  };

  const goBack = () =>
  {
    navigate(-1);
  };

  const onMapClicked = () =>
  {
    if (showingInfoWindow) setShowingInfoWindow(true);
  };

  let numericFormatter = new Intl.NumberFormat('en-UK', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const numberWithCommas = (x) =>
  {
    return numericFormatter.format(x);
  };

  const showMarkers = () =>
  {
    var defaultIcon = {
      scaledSize: new props.google.maps.Size(20, 30), // scaled size
    };

    var highlightedIcon = {
      scaledSize: new props.google.maps.Size(20, 30), // scaled size
    };
    const index = 1;
    return (
      <Marker
        position={{
          lat: propertyCord.property?.googleMapLatitude,
          lng: propertyCord.property?.googleMapLongitude,
        }}
        icon={color == index ? highlightedIcon : defaultIcon}
        onClick={() =>
          onMarkerClick({ ...propertyCord.property }, index)
        }
      ></Marker>
    );
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        padding: 0,
        margin: 0,
        position: 'absolute',
        top: 0,
        left: 0,
      }}
    >
      <Map
        google={props.google}
        zoom={15}
        style={mapStyles}
        onClick={onMapClicked}
        initialCenter={{
          lat: propertyCord?.property?.googleMapLatitude,
          lng: propertyCord?.property?.googleMapLongitude,
        }}
      >
        {showMarkers()}
      </Map>
      {selectedPlace && (
        <div
          className="col-12 col-md-6 col-xl-4 d-flex flex-row justify-content-center align-items-center border rounded mb-md-0 property-details card-1"
          style={{ fontSize: '10px', width: '100%' }}
        >
          <div className="item-map">
            <Link
              to={{
                pathname: '/PropertyDetails',
                query: {
                  property: selectedPlace,
                },
                prevPath: { path: location.pathname },
                prevBackPath: { path: propertyCord.searchPath },
              }}
              style={{ textDecoration: 'none', color: 'black' }}
            >
              {selectedPlace?.externalFiles &&
                selectedPlace?.externalFiles?.length !== 0 ? (
                <img
                  alt="small"
                  src={`${AppConstants.BASE_URL_FILE}${handleSmallImages(
                    selectedPlace?.externalFiles[0]?.filePath,
                  )}`}
                  className="img-fluid w-100 properties-image-map"
                />
              ) : (
                <img
                  alt="default"
                  src={noImage}
                  className="img-fluid w-100 properties-image-map"
                />
              )}
            </Link>
            {selectedPlace?.forSaleOrToLet === false ? (
              <small
                className="for-Sale-or-for-Let"
                style={{ background: 'green' }}
              >
                For Sale
              </small>
            ) : (
              <small
                className="for-Sale-or-for-Let"
                style={{ background: 'red' }}
              >
                To Let
              </small>
            )}
            <small className="ribbon">
              Ref:{selectedPlace?.propertyRef}
            </small>
          </div>
          <div
            className="col-5 non text-left mb-2"
            style={{ fontSize: '10px' }}
          >
            <p className="font-weight-bold mb-0 title mt-4">
              {selectedPlace?.propertyTypeName}
            </p>
            <p className="font-weight-bold mb-0 title">
              {selectedPlace?.localityName}
            </p>
            <p className="font-weight-bold mb-2 title">
              {selectedPlace?.propertyStateName}
            </p>
            <p className="mb-2">
              €
              {selectedPlace?.forSaleOrToLet === false
                ? numberWithCommas(
                  selectedPlace?.propertyForSale?.price,
                )
                : numberWithCommas(
                  selectedPlace?.propertyToLet?.longLetRate,
                )}
            </p>
            <p className="m-0">{selectedPlace?.ByAppointment}</p>
            <p className="m-0">
              <span className="font-weight-bold">
                <i className="fas fa-bed mr-2"></i>{' '}
              </span>
              {selectedPlace?.bedrooms} bedrooms
            </p>
            <p
              className="m-0"
              style={{ fontSize: '12px !important' }}
            >
              <span className="font-weight-bold">
                <i className="fas fa-expand fa-lg mr-2"></i>{' '}
              </span>
              {selectedPlace?.areaSqMtrs} SQMT
            </p>
            <p
              className="m-0"
              style={{ fontSize: '12px !important' }}
            >
              <span className="font-weight-bold">
                <i className="fas fa-map fa-lg mr-2"></i>{' '}
              </span>
              <a href={'https://www.google.com/maps/search/?api=1&query=' + selectedPlace?.googleMapLatitude + ',' + selectedPlace?.googleMapLongitude}
                className="font-weight-bold text-primary" target="_blank">Directions</a>
            </p>
            <div
              className="close-card-map"
              onClick={(e) =>
              {
                e.stopPropagation();
                setSelectedPlace(null);
                setColor(null);
              }}
            >
              <i className="fas fa-times fa-lg"></i>
            </div>
          </div>
        </div>
      )}
      <div className="close-map card-1 cursor-item" onClick={goBack}>
        <i className="fas fa-times fa-2x"></i>
      </div>
    </div>
  );
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_MAP_KEY,
})(SingleMap);
